export const sessionStorageKeys = {
    categoryLink: 'categoryLink',
    collectionLink: 'collectionLink',
    // Add more keys here as needed
  }